// extracted by mini-css-extract-plugin
module.exports = {"border-input":"BorderInput_border-input__1zmC2"};